<div class="table-responsive">
  <button mat-raised-button class="createButton" color="accent" (click)="createCategory()">Kategorie erstellen</button>
  <table mat-table [dataSource]="categories" class="mat-elevation-z8">
    <!-- Columns for Order interface -->
    <ng-container matColumnDef="identifier">
      <th mat-header-cell *matHeaderCellDef>Bezeichner</th>
      <td mat-cell *matCellDef="let category">{{ category.identifier }}</td>
    </ng-container>

    <ng-container matColumnDef="text">
      <th mat-header-cell *matHeaderCellDef>Text</th>
      <td mat-cell *matCellDef="let category">{{ category.text }}</td>
    </ng-container>

    <ng-container matColumnDef="sortId">
      <th mat-header-cell *matHeaderCellDef>Sortierung</th>
      <td mat-cell *matCellDef="let category">{{ category.sortId }}</td>
    </ng-container>

    <ng-container matColumnDef="showOnFrontend">
      <th mat-header-cell *matHeaderCellDef>Aktiv</th>
      <td mat-cell *matCellDef="let category">{{ category.showOnFrontend | yesNo }}</td>
    </ng-container>

    <ng-container matColumnDef="allowComment">
      <th mat-header-cell *matHeaderCellDef>Kommentar erlauben</th>
      <td mat-cell *matCellDef="let category">{{ category.allowComment | yesNo }}</td>
    </ng-container>

    <ng-container matColumnDef="details">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let category">
        <button mat-icon-button (click)="showCategoryDetails(category)">
          <mat-icon>edit</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let category">
        <button mat-icon-button (click)="deleteCategory(category)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <!-- Define the displayed columns order -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let category; columns: displayedColumns;"></tr>
  </table>
</div>
